// web-v2/src/lib/insurance-line.js
//
// ESM twin of utils/insurance-line.js (AIRPORT-PROPERTY-LINE-REPAIR Ship 0).
// tests/insurance-line.test.js (server gate) pins PROPERTY_FAMILY in both
// files together; change them in lockstep. See the server file for the
// consolidation history.

export const PROPERTY_FAMILY = ['Airport Property', 'Hangar', 'Property'];

export function isPropertyLine(value) {
  return PROPERTY_FAMILY.includes(value || '');
}

export function resolveLine(deal) {
  const raw = deal?.Insurance_Line || null;
  const hasBrData = Boolean(deal?.Builders_Risk_Data || deal?.BR_Status);
  let canonical;
  if (raw && isPropertyLine(raw)) canonical = 'Airport Property';
  else if (raw) canonical = raw;
  else if (hasBrData) canonical = 'Airport Property';
  else canonical = 'Aviation';

  const isProperty = canonical === 'Airport Property';
  const subtype = isProperty ? (hasBrData ? 'construction' : 'occupied') : null;
  return {
    canonical,
    subtype,
    isProperty,
    isHangar: isProperty && subtype === 'occupied',
    isBuildersRisk: isProperty && subtype === 'construction',
    isCommercial: canonical === 'Commercial',
    isAviation: !isProperty && canonical !== 'Commercial',
    display: !isProperty
      ? canonical
      : (subtype === 'construction'
        ? 'Airport Property · Builders Risk'
        : 'Airport Property · Occupied Hangar'),
  };
}
